/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MobileNotificationGridItemViewModel } from "../types/MobileNotificationGridItemViewModel.ts";
import { eMobileNotificationStatusSchema } from "./eMobileNotificationStatusSchema.ts";

export const mobileNotificationGridItemViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("Identificador único da notificação."),
  ),
  sentFullAt: z
    .string()
    .datetime()
    .describe(
      "Data e hora do último envio concluído. Quando não enviada ainda, reflete a data de agendamento ou criação.",
    )
    .nullish(),
  createdDate: z.string().datetime().describe("Data de criação.").nullish(),
  title: z.string().describe("Título da notificação.").nullish(),
  message: z.string().describe("Corpo/Mensagem da notificação.").nullish(),
  classStudentNames: z
    .array(z.string())
    .describe(
      "Nomes das turmas associadas. Retorna uma descrição resumida quando há mais de 3 turmas, caso contrario, retorna os 3 primeiros.",
    )
    .nullish(),
  totalStudentsSent: z.optional(
    z
      .number()
      .int()
      .describe(
        "Soma de tokens de usuários que receberam a notificação em todas as turmas.",
      ),
  ),
  createdBy: z
    .string()
    .describe("Nome completo do usuário que criou a notificação.")
    .nullish(),
  status: z.optional(
    z
      .lazy(() => eMobileNotificationStatusSchema)
      .describe(
        "1 = Draft | 2 = Scheduled | 3 = Processing | 4 = Completed | 5 = Canceled | ",
      ),
  ),
  urlExternal: z.string().nullish(),
}) as unknown as ToZod<MobileNotificationGridItemViewModel>;
